import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { injectIntl, intlShape } from "react-intl";
import Select from "react-select";
import {
  fetchClaimBenefitPlans,
  fetchNewSpendingAccounts,
} from "../../actions/claimAccountsActions";
import { Card, Loader } from "cxa-components";
import messages from "components/messagesDescription";
import ClaimAccountDetail from "./ClaimAccountDetail";

const ClaimAccountsPagePP = ({ intl }) => {
  const [activePlanYear, setActivePlanYear] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchClaimBenefitPlans());
  }, []);

  useEffect(() => {
    const activeBenefitPlan = claimAccountsData.benefitPlans.find(x => x.planID === activePlanYear);
    dispatch(fetchNewSpendingAccounts(activeBenefitPlan && activeBenefitPlan.planEnd));
  }, [activePlanYear]);

  const onPlanYearChanged = e => {
    setActivePlanYear(e.value);
  };

  const claimAccountsData = useSelector(state => state.claimAccounts);
  const defaultPlan = claimAccountsData.benefitPlans.find(x => x.isDefault);
  const planYears = claimAccountsData.benefitPlans.map(item => ({
    value: item.planID,
    label: item.planName,
  }));

  if (claimAccountsData.isFetching || claimAccountsData.benefitPlans.length <= 0) {
    return <Loader />;
  }

  return (
    <div>
      <h3>
        <span style={{ color: "#000000" }}>
          {intl.formatMessage(messages.statementOfAccountDescription)}
        </span>
      </h3>
      <table style={{ margin: "20px 0" }}>
        <tr>
          <td>{intl.formatMessage(messages.claims.planYears)}</td>
          <td style={{ width: "160px", padding: "0 20px" }}>
            <Select
              value={activePlanYear || (defaultPlan && defaultPlan.planID)}
              defaultValue={defaultPlan && defaultPlan.planID}
              onChange={onPlanYearChanged}
              options={planYears}
            ></Select>
          </td>
        </tr>
      </table>
      <Card>
        <span className="account-balance-label">
          {intl.formatMessage(messages.yourAccountBalanceDescription)}
        </span>
        {claimAccountsData.accounts.length > 0 ? (
          claimAccountsData.accounts.map(account => {
            return (
              <ClaimAccountDetail
                key={account.accountType}
                account={account}
                uiConfigs={claimAccountsData.uiConfigs}
              />
            );
          })
        ) : (
          <p>{intl.formatMessage(messages.noAccountsDescription)}</p>
        )}
      </Card>
    </div>
  );
};

ClaimAccountsPagePP.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(ClaimAccountsPagePP);



// WEBPACK FOOTER //
// ./components/claim/ClaimAccountsPagePP.js